<template>
  <div>
    <button
      class="btn btn-danger btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="unlock quote"
      @click="fnShowModal()"
      :disabled="fnIsDisabledUnlockButton()"
    >
      <i class="las la-lock"></i>Unlock
    </button>

    <b-modal ref="userModal" hide-footer title="Unlock Submitted Quote?">
      <div class="d-block">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12">
            <p>
              Unlocking this quote will allow you to make amendments to it.
              After editing, please re-submit the finance application for
              processing.
            </p>
            <p>Are you sure you want to unlock the submitted quote?</p>
          </div>
        </div>
        <hr />
        <div class="text-right">
          <button
            type="button"
            @click="fnQuoteUnlock()"
            class="btn btn-danger btn-sm mr-2"
          >
            Yes, Unlock
          </button>
          <button type="button" class="btn btn-dark btn-sm" @click="hideModal">
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as authService from '../../services/auth.service'

export default {
  name: 'ModelUnlockMessage',
  props: ['propsData'],
  components: {},
  data() {
    return {
      quoteId: this.$route.params.quoteId,
      loginUser: {}
    }
  },
  methods: {
    ...mapActions(['fetchIsLock']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    fnQuoteUnlock() {
      this.fetchIsLock(false)
      this.hideModal()
    },
    /**
     * Disabled unlock button
     * if status is 6, 9,10,11,12 and if not admin
     */
    fnIsDisabledUnlockButton() {
      let status = false
      const { role_id } = this.loginUser
      if (
        (this.propsData.status == 6 ||
          this.propsData.status == 9 ||
          this.propsData.status == 10 ||
          this.propsData.status == 11 ||
          this.propsData.status == 12) &&
        role_id != 1
      ) {
        status = true
      }

      return status
    }
  },
  created() {
    this.loginUser = authService.getUserFromToken()
  }
}
</script>
